/**
 * Returns an array products, filtered by the group attribute
 * @param { Array } products       - The array of products
 * @param {boolean} displayGroup   - Conditional variable for filtering cases: if true, groups/series are filtered, otherwise, variations are filtered
 * @param {boolean} areFiltersApplied - Indicates whether filters are applied.
 * @returns {Array}                - The array of filtered products
 */
export const filterProductByGroup = (products, displayGroup, areFiltersApplied) => {
  const productGroups = products.filter((product) => product.group || (!product.group && !product.groupId));

  if (areFiltersApplied) {
    return productGroups.flatMap((product) => {
      if (product.group) {
        // If all models in a group are filtered, return only the group; otherwise return each filtered model in that group
        const allModelsAreFiltered = product.productIds?.every((id) => products.find((model) => model.id === id));
        return allModelsAreFiltered ? product : products.filter((model) => model.groupId === product.id);
      }
      return product;
    });
  }

  return displayGroup
    ? productGroups
    : products.filter((product) => !product.group);
};

export default filterProductByGroup;
